import { useGetStaticAssetUrl } from '@change-corgi/core/react/assets';

import { MEMBERSHIP_COUNTRY_CONFIG } from 'src/app/pages/about/impact/shared/consts';
import { useCountryCode } from 'src/app/shared/hooks/l10n';

type Result = ModelHookResult<{
	imageUrl?: string;
}>;

export function useGetCtaImage(): Result {
	const countryCode = useCountryCode();
	const getStaticAssetUrl = useGetStaticAssetUrl();
	const result =
		countryCode in MEMBERSHIP_COUNTRY_CONFIG
			? MEMBERSHIP_COUNTRY_CONFIG[countryCode]
			: MEMBERSHIP_COUNTRY_CONFIG.default;

	return {
		data: { imageUrl: result.imageUrl ? getStaticAssetUrl(result.imageUrl) : undefined },
	};
}
